import SpriteSymbol from "../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "careers",
  "use": "careers-usage",
  "viewBox": "0 0 32 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 30\" id=\"careers\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M28 28H4a2 2 0 01-2-2V14h28v12a2 2 0 01-2 2zM4 6h24a2 2 0 012 2v4H2V8a2 2 0 012-2zm8-3a1 1 0 011-1h6a1 1 0 011 1v1h-8zm16 1h-6V1a1 1 0 00-1-1H11a1 1 0 00-1 1v3H4a4 4 0 00-4 4v18a4 4 0 004 4h24a4 4 0 004-4V8a4 4 0 00-4-4z\" data-name=\"Fill-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol